import { t } from '@base/utils/helpers';
import styles from '../styles/moreGamesModal.module.scss';
import Tabs, { TabPane } from '@ui-kit/components/tabs';
import Cribbage from './cribbage';
import Dominoes from './dominoes';
import Backgammon from './backgammon';
import GinRummy from './ginRummy';
import RedMahjong from './redMahjong';

const tabs = [
  {
    title: 'cribbage',
    content: <Cribbage />,
  },
  {
    title: 'dominoes',
    content: <Dominoes />,
  },
  {
    title: 'backgammon',
    content: <Backgammon />,
  },
  {
    title: 'gin rummy',
    content: <GinRummy />,
  },
  {
    title: 'red mahjong',
    content: <RedMahjong />,
  },
];

function MoreGamesModal() {
  return (
    <div className={styles.moreGames}>
      <Tabs className='modalTabs'>
        {tabs.map((tab, i) => (
          <TabPane
            label={
              <span className={styles.label}>
                {t(tab.title)}
              </span>
            }
            key={i + 1}
            className={styles.tab}
          >
            {tab.content}
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
}

export default MoreGamesModal;
